import React, { useEffect, useState, Fragment } from "react";
import CardSelector from "../../atoms/inputElemets/CardSelector";
import { useDispatch, useSelector } from "react-redux";
import { resetBluePrint } from "../../../store/blueprint/actions";
import { getReRender } from "../../../store/global/selectors";
import { read } from "../../../store/blueprint/actions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Page from "../../atoms/page";
import Typography from "@material-ui/core/Typography";
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../../config/colors';
import { invokeGetService } from "../../../store/global/actions";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import { useDebouce } from "../../../utils/customHooks";
import SelectBluePrintImport from "../../molecules/layout/BluePrintImporter";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import zIndex from "@material-ui/core/styles/zIndex.js";

const useStyles = makeStyles((theme) => ({
	columnContainer: {
		display: 'flex',
		flexDirection: 'column',
		padding: '0 !important',
	},
	alertContainer: {
		marginTop: '100px',
	},
	cardContainer: {
		height: '74vh',
		maxHeight: '74vh',
		overflowY: 'initial',
		padding: '0px !important',
		'&::-webkit-scrollbar': {
			width: '0.5em',
			height: '0.5em',

		},
		marginTop: '96px',
		'&::-webkit-scrollbar-track': {
			boxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
			webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)'
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#ccc',
			borderRadius: '5px'
		},
		transition: 'height 0.3s ease-out',
		opacity: 1
	},
	hideCardContainer: {
		height: 0,
		overflow: 'hidden',
		opacity: 0,
		transition: 'height 0.3s ease-out'
	},
	titleContainer: {
		position: 'sticky',
		top: 0,
		backgroundColor: Colors.primary,
		color: '#fff',
		zIndex: 1,
		padding: 5,
	},
	title: {
		float: 'left',
		marginLeft: 10,
		fontSize: '1.5rem',
		fontWeight: 600,
		marginTop: 2
	},
	arrowIcon: {
		marginRight: 5,
		cursor: 'pointer'
	},
	searchBar: {
		background: '#ffff',
		height: '40px',
		padding: '0.3rem 0.5rem',
		border: '1px solid rgba(0,0,0,0.2)',
		borderRadius: '4px',
		maxWidth: '50rem',
		width: '40%',
		marginRight: '20px',
		display: 'flex'
	},
	searchInput: {
		fontSize: '1rem',
		fontWeight: '400',
		border: 'none',
		outline: 'none',
		background: 'none',
		'& option': {
			fontSize: '1rem'
		},
		'&:before': {
			display: 'none',
			outline: 'none'
		},
		'&:after': {
			display: 'none',
			outline: 'none'
		},
		'& input': {
			fontSize: '1rem'
		}
	},
	textCapitalise: {
		textTransform: 'capitalize'
	},
	titleHeader: {
		display: 'flex',
		width: '100%',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: '1.8rem 0',
		position: 'fixed',
		zIndex: '101',
		background: '#f5f5f58c'

	},
	createBPButton: {
		background: '#5f728d',
		height: '40px',
		color: '#ffffff',
		display: 'flex',
		alignItems: 'center',
		padding: '0.2rem 2rem',
		textTransform: 'capitalize',
		width: '200px',
		'&:hover': {
			background: '#414a55',
		}
	}

})
);

const Dashboard = (props) => {
	const push = props.history.push;
	return (
		<Page title="Dashboard" customStyle={{paddingTop: 0}} >
			<Grid item xs={12} className="appselector_container" style={{paddingTop: 0}}>
				<AppSelector push={push} />
			</Grid>
		</Page>
	);
};

export default Dashboard;
/// props.goTo(`/blueprint/${blueprintId}/information_flow`);
const AppSelector = (props) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const reRender = useSelector(getReRender);
	const history = useHistory();

	const [selectedOption, setSelectedOption] = useState("");
	const [loading, setLoading] = useState(true);
	const [sharedBPExpand, setSharedBPExpand] = useState(false);
	const [myBPExpand, setMyBPExpand] = useState(true);
	const [blueprints, setBlueprints] = useState([]);
	const [blueprintsRaw, setBlueprintsRaw] = useState([])
	const [selectedItem, setselectedItem] = useState("");
	const [search, setSearch] = useState('')
	const [filter, setFilter] = useState('all')
	const selectedItemProps = props;
	const debouncedSearch = useDebouce(search, 300)
	const [isCreateBp, setCreateBp] = useState(false);


	const closeCreateModal = () => {
		if (!isCreateBp) {
			dispatch(resetBluePrint())
		}
		setCreateBp((prev) => !prev)
	}

	const gotoCreatedBP = (blueprintId = "") => {
		history.push(`/blueprint/${blueprintId}/system-model`);
		closeCreateModal();
	};

	const onClick = (value) => setSelectedOption(value);

	const onSelect = (selectedValue) => setselectedItem(selectedValue);

	const onImport = () => {
		setLoading(true);
		dispatch(read(selectedOption, true)).then((res) => {
			setLoading(false);
			if (res.status) {
				props.push(`/blueprint/${selectedOption}/system-model`);
			}
		});
	};

	const toggleSection = () => {
		setMyBPExpand(!myBPExpand);
		setSharedBPExpand(!sharedBPExpand);
	}

	useEffect(() => {
		const filterResult = blueprintsRaw.filter(item => filter === 'own' ? !item?.bpOwner : filter === 'shared' ? item.bpOwner : item)
		let searchResult = filterResult.filter(item => (debouncedSearch && debouncedSearch !== '') ? item.name?.toLowerCase()?.includes(debouncedSearch.toLowerCase()) : item)
		searchResult = searchResult.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
		setBlueprints(searchResult)
	}, [debouncedSearch, filter, blueprintsRaw])

	useEffect(() => {
		setLoading(true)
		dispatch(invokeGetService('getBlueprintList')).then((response) => {
			//@geting details of a blueprint from invokeGetService
			//@response:[{createdAt(string),description(string),name(string),slug(string),updatedAt(string),updatedAt(string)}]

			if (response?.status == true && response?.data) {
				
				let structuredData = [...response.data?.myBlueprints, ...response.data?.sharedBlueprints].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
				// setBlueprints(structuredData)
				setBlueprintsRaw(structuredData)
				setLoading(false)
			}
		});
	}, [reRender]);

	// useMemo(() => {
	// 	dispatch(triggerTour({ currentTour: 'dashboard' }))
	// }, [])

	return (
		<Fragment>
			{isCreateBp && <SelectBluePrintImport open={isCreateBp} handleClose={closeCreateModal} gotocreate={gotoCreatedBP} />}
			<Grid container direction="column" style={{padding: 0}} spacing={1}>
				<Grid item xs={12} className={classes.columnContainer}>
					<Grid xs={12} className={`${classes.titleHeader} blueprints_list_header`}>
						<div className={classes.searchBar} data-ui-tour-id="search-bar">
							<input type="text" id="search-input" placeholder="Search blueprints" onChange={event => setSearch(event.target.value)} className={classes.searchInput} style={{ flex: 1 }} />
							<select className={classes.searchInput} id='dashboard-filter-selector' data-ui-tour-id="title-text" onChange={event => setFilter(event.target.value)} value={filter}>
								<option value='all' selected>All Blueprints</option>
								<option value='own'>My Blueprints</option>
								<option value='shared'>Shared Blueprints</option>
							</select>
						</div>
						
						<Button
							className={`${classes.createBPButton} create-bp-btn`}
							onClick={() => {
								setCreateBp(true)
							}}
							id="create-bp-btn"
							data-ui-tour-id="create-bp-btn"
						>
							{" "}
							Create Blueprint
						</Button>
					</Grid>
					{((blueprints?.length === 0 || blueprintsRaw?.length === 0) && !loading) &&
					<div className={classes.alertContainer}>
						<Alert severity="info" style={{ marginTop: 8 }}>
							{
								blueprintsRaw.length === 0 ? "No blueprints created yet!" : "No blueprints found"
							}
						</Alert>
					</div>
					}
					<div className={myBPExpand === true ? classes.cardContainer : classes.hideCardContainer}>
						{
							loading ?
								<div style={{ minHeight: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
									<LoaderWithProgress isLoader={true} />
								</div>
								:
								<CardSelector
									direction={"row"}
									justify={"flex-start"}
									list={blueprints}
									onClick={onClick}
									onSelect={onSelect}
									value={selectedOption}
									isFromDashboard={true}
									isOwnBlueprint={true}
								/>
						}
					</div>
				</Grid>
			</Grid>
			{/* </Fragment> */}
		</Fragment>

	);
};